import React, { useEffect, useState } from "react";
import { RouteComponentProps, useHistory } from "react-router-dom";
import * as Sentry from "@sentry/browser";

export const SsoErrorScreen: React.FC<RouteComponentProps> = () => {
  const history = useHistory<{
    providerId: string;
    error: string;
    desc: string;
  }>();
  const [providerId, setProviderId] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [errDesc, setErrDesc] = useState<string | null>(null);
  useEffect(() => {
    const qsProviderId: string = history.location.state.providerId;
    const qsError = history.location.state.error;
    const qsErrorDesc = history.location.state.desc;
    setProviderId(qsProviderId);
    setError(qsError);
    setErrDesc(qsErrorDesc);
    Sentry.captureMessage(
      `CSE: User with SSO '${qsProviderId}' encountered error: '${qsError}' with description: '${qsErrorDesc}'`
    );
  }, [history.location]);

  return (
    <div style={{ padding: "80px", fontSize: "large" }}>
      <h1>SSO Error</h1>
      Semgrep encountered an SSO error{" "}
      <strong>
        <code>{error}</code>
      </strong>
      . Please email support@r2c.dev and let us know so we can fix it!
      <br />
      <br />
      <h3>ProviderId</h3>
      <pre>{providerId}</pre>
      <h3>Description</h3>
      <pre>{errDesc}</pre>
    </div>
  );
};
